import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { DocumentStats } from '../../lib/api';

interface StatsCardsProps {
  stats: DocumentStats;
}

export function StatsCards({ stats }: StatsCardsProps) {
  return (
    <div className="grid gap-4 md:grid-cols-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Total Documents</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.total_documents}</div>
          <p className="text-xs text-muted-foreground">All documents</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Folders</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.total_categories}</div>
          <p className="text-xs text-muted-foreground">Document folders</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Files</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.documents_by_type.file}</div>
          <p className="text-xs text-muted-foreground">Uploaded files</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">External Links</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.documents_by_type.url}</div>
          <p className="text-xs text-muted-foreground">External URLs</p>
        </CardContent>
      </Card>
    </div>
  );
}
